/** Regional danger (plan §5 R4): region × archetype × anchor multipliers from reach-systems.json. */
import type { StarSystem } from '../types'
import { defaultReachSystemsConfig, type ReachSystemsConfig } from './config'

/** A system's danger scale: the region multiplier × the archetype's and the anchor's (1 when unlisted). */
export function dangerOf(
  system: Pick<StarSystem, 'region' | 'archetype' | 'anchor'>,
  cfg: ReachSystemsConfig = defaultReachSystemsConfig(),
): number {
  const d = cfg.danger
  const archetype = d.archetype[system.archetype] ?? 1
  const anchor = system.anchor === null ? 1 : (d.anchor[system.anchor] ?? 1)
  return d.region[system.region] * archetype * anchor
}
